import { render, staticRenderFns } from "./AnnouncementSendForm.vue?vue&type=template&id=79ed47ce"
import script from "./AnnouncementSendForm.vue?vue&type=script&lang=js"
export * from "./AnnouncementSendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports